import React, { FC, Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@material-ui/core';

import {
  useUpdateClientFollowMappingMutation,
  ClientFollowMappingFragment,
  GroupFragment,
} from 'api';
import { GroupPicker } from 'components/Pickers';
import { useNotify } from 'hooks';
import { useUpdateClientFollowMapping } from 'features/admin/updaters';

interface IProps {
  mapping: ClientFollowMappingFragment;
}

const GroupsRequired: FC<IProps> = ({ mapping }) => {
  const { t } = useTranslation();
  const notify = useNotify();

  const [activeGroups, setActiveGroups] = useState(mapping.required_groups);
  const mutationOptions = useUpdateClientFollowMapping();
  const { mutate, isLoading } = useUpdateClientFollowMappingMutation({
    onSuccess: editNotify,
    ...mutationOptions,
  });

  function editNotify() {
    const message = t('components:savedSuccessfully');
    notify.info({ message });
  }

  function getRequiredValues() {
    const { id, title, mapping_status, all_users } = mapping;
    return { id, title, mapping_status, all_users };
  }

  function handleChange(groups: GroupFragment[]) {
    // Manage locally to compensate for API
    setActiveGroups(groups);

    mutate({
      data: {
        ...getRequiredValues(),
        required_group_ids: groups.map(group => group.id),
      },
    });
  }

  return (
    <Fragment>
      <Typography variant="subtitle2">{t('common:required')}</Typography>
      <Typography color="textSecondary">{t('admin:onboardingGroupsRequired')}</Typography>
      <GroupPicker
        scope="admin"
        selectedGroups={activeGroups}
        onSelectedGroupsChange={handleChange}
        saving={isLoading}
        excludeIds={activeGroups.map(group => group.id)}
      />
    </Fragment>
  );
};

export default GroupsRequired;
